export const editStatusInfo = [
  { color: "rgba(0, 0, 0, 0.1)", text: "미참여" },
  { color: "white", text: "미완료" },
  { color: "#FFEB3B", text: "수정중 (임시저장)" },
  { color: "#80BA4C", text: "완료" },
];

// ! "Unblind" jd의 순서 업데이트 필요.
// export const divisionInfo = {
//   MW: { color: "#91E942", jd: ["MW Manager", "MW"] },
//   CO: { color: "#80BA4C", jd: ["CO Manager", "CPM", "CRA", "CTA"] },
//   DM: { color: "#0FBD0C", jd: ["DM Manager", "DPM", "DRM"] },
//   SA: { color: "#55842B", jd: ["SA Manager", "STAT", "SP"] },
//   PV: { color: "#40954A", jd: ["PV Manager", "PVA"] },
//   RA: { color: "#00B372", jd: ["RA Manager", "RAA"] },
//   QA: { color: "#00754B", jd: ["QA Manager", "QAA"] },
//   OF: { color: "#00472D", jd: ["OF Manager", "OFA"] },
// };
export const divisionInfo = {
  MW: { color: "#91E942", jd: ["MWM", "MWA"] },
  CO: { color: "#80BA4C", jd: ["CRM", "CPM", "PM", "CRA", "SSU", "CTA"] },
  DM: { color: "#0FBD0C", jd: ["DMM", "DPM", "DRM", "CDA", "DMA"] },
  SA: { color: "#55842B", jd: ["SAM", "SASP", "STAT.M", "STAT"] },
  PV: { color: "#40954A", jd: ["PVM", "PVA"] },
  RA: { color: "#00B372", jd: ["RAM", "RAA", "D", "M", "S1", "S2", "J"] },
  QA: { color: "#00754B", jd: ["QAM", "QAA"] },
  OF: { color: "#00472D", jd: ["OFM", "OFA"] },
};

export const divisionOrder = ["MW", "CO", "DM", "SA", "PV", "RA", "QA", "OF"];

export const fontValues = [
  "Arial",
  "Georgia",
  "Tahoma",
  "Times New Roman",
  "Verdana",
];

export const issueFormData = {
  id: "Issue tracking을 위해 중복되지 않도록 고유한 번호를 순차적으로 부여한다. 고유한 번호는 발견자의 부서+전체 일련번호3자리로 정한다.",
  statCodeId: `Issue의 상태`,
  gradCodeId: `RM SOP에 따라 Risk Level을 구분`,
  typeCodeId: `Issue의 Type`,
  intShr: `프로젝트 미팅에서 내부 공유할 필요가 있는지에 대한 항목`,
  issDescr: `Issue에 대한 구체적인 내용으로 언제, 어디서, 누가, 무엇을, 왜 이슈가 발생하였는지 기재`,
  oEmployeeNo: `해당 Issue의 책임 담당자`,
  iDate: `Issue가 처음 제기된 날짜`,
  assocdId: `해당 Issue가 발생하게 된/또는 연관있는 이전 Issue의 ID`,
  eBEmployeeNo: `Issue를 처음 접한 담당자의 이름`,
  rootCuz: `해당 이슈가 발생되게 된 원인`,
  iSum: `Issue 발생으로 인하여 발생하는 이후 업무의 영향을 명확하게 작성`,
  ac: `Issue를 해결하기 위한 해결책`,
  expResDate: `Issue을 해결할 수 있을 것으로 예상되는 날짜`,
  actResDate: `실제 Issue가 해결된 날짜`,
  fResR: `이슈가 해결된 내용에 대한 구체적인 설명`,
};

export const paletteData = [
  "Material",
  "Soft Pastel",
  "Harmony Light",
  "Pastel",
  "Bright",
  "Soft",
  "Ocean",
  "Office",
  "Vintage",
  "Violet",
  "Carmine",
  "Dark Moon",
  "Soft Blue",
  "Dark Violet",
  "Green Mist",
];

export const sizeValues = [
  "8pt",
  "10pt",
  "12pt",
  "14pt",
  "16pt",
  "18pt",
  "20pt",
  "24pt",
  "36pt",
];
